export default __webpack_public_path__ + "static/media/personalTrackers.1097dcf5.png";